var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"trigger-container",class:{ 'trigger-container-active': _vm.isActive },attrs:{"cols":"auto"}},[_c('element-trigger-icon',{attrs:{"trigger":_vm.trigger}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }